import { NotificationManager } from 'react-notifications';
import axios from 'axios';

import { ILoginForm } from './types';

export async function fetchToken(data: ILoginForm): Promise<{ accessToken: string }> {
  try {
    const res = await axios.post('api/v1/jwt-login', data);
    return res.data;
  } catch (error) {
    NotificationManager.error('Auth failed');
    return { accessToken: '' };
  }
}
